module.exports = __webpack_public_path__ + "img/ic_logo_menu.4e110a14.svg";